var heading = {
    base: {
        boxSizing: "border-box",
        marginBlockEnd: 0,
        marginBlockStart: 0,
    },
    variants: {
        font: {
            h1: { font: "h1" },
            h2: { font: "h2" },
            h3: { font: "h3" },
            h4: { font: "h4" },
            h5: { font: "h5" },
            h6: { font: "h6" },
        },
        level: {
            1: { font: "h1" },
            2: { font: "h2" },
            3: { font: "h3" },
            4: { font: "h4" },
            5: { font: "h5" },
            6: { font: "h6" },
        },
    },
    defaultProps: {
        font: "h1",
    },
};

export { heading };
//# sourceMappingURL=heading.js.map
